import React from 'react';
import { Typography, Spin } from 'antd';

const { Title, Text } = Typography;
const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JWT_KEY  = 'drupi_social_jwt';

export const UserIdPage: React.FC = () => {
  const [userId, setUserId]   = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError]     = React.useState<string | null>(null);

  React.useEffect(() => {
    (async () => {
      const jwt = localStorage.getItem(JWT_KEY);
      if (!jwt) {
        setError('No estás autenticado.');
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${API_BASE}/drupi/userid`, {
          headers: { 'Authorization': `Bearer ${jwt}` },
        });
        if (!res.ok) {
          setError(`HTTP ${res.status}`);
          return;
        }
        const data = await res.json();
        setUserId(data.user_id);
      } catch (e: any) {
        setError(e.message || 'Error desconocido');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8f9fa',
      gap: 12,
    }}>
      <Title level={4} style={{ margin: 0, color: '#6b7280' }}>Tu User ID</Title>
      {loading && <Spin />}
      {error && <Text type='danger'>{error}</Text>}
      {userId && (
        <Text
          copyable
          code
          style={{ fontSize: 16, wordBreak: 'break-all', maxWidth: 480, textAlign: 'center' }}
        >
          {userId}
        </Text>
      )}
    </div>
  );
};
